export enum NoCostLoginMethod {
  Biometrics = 1,
  QuickLogin = 2,
}

export enum NoCostLoginOperation {
  enable = 'enable',
  disable = 'disable',
}
